import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog';
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle';
import CreateLeadSourceDialogContent from './CreateLeadSourceDialogContent';

const CreateLeadSourceDialog = ({
  open, onCancel, onSave, leadSourceName,
}) => (
  <Dialog fullWidth open={open}>
    <DialogTitle>New lead source</DialogTitle>
    <CreateLeadSourceDialogContent
      onCancel={onCancel}
      onSave={onSave}
      leadSourceName={leadSourceName}
    />
  </Dialog>
);

CreateLeadSourceDialog.propTypes = {
  open: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  leadSourceName: PropTypes.string,
};

CreateLeadSourceDialog.defaultProps = {
  open: false,
  leadSourceName: '',
};

export default CreateLeadSourceDialog;
